import { render } from "./FormularioComponent.vue?vue&type=template&id=30a13362&scoped=true"
import script from "./FormularioComponent.vue?vue&type=script&lang=js"
export * from "./FormularioComponent.vue?vue&type=script&lang=js"

import "./FormularioComponent.vue?vue&type=style&index=0&id=30a13362&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a13362"]])

export default __exports__